module.exports = "<div #map></div>\n<!--\n<div class=\"mapZoomControlWrapper\">\n  <div class=\"group\">\n    <div class=\"button\" (click)=\"zoomIn()\"><img src=\"/assets/img/icons/zoom-in.svg\"></div>\n    <div class=\"button\" (click)=\"zoomOut()\"><img src=\"/assets/img/icons/zoom-out.svg\"></div>\n  </div>\n  <div class=\"button group\" (click)=\"resetZoom()\"><img src=\"/assets/img/icons/zoom-reset.svg\"></div>\n</div>\n-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/map-base/map-base.component.html
// module id = ./src/app/common/map-base/map-base.component.html
// module chunks = main